(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  // Smooth AJAX newsletter signup – no page reload
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.email-capture form');
    if (!form) return;

    const messageEl = form.querySelector('.email-capture__message');
    const successEl = form.querySelector('.email-capture__success');
    const errorEl = form.querySelector('.email-capture__error');

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      // Hide previous messages
      messageEl.style.display = 'none';
      successEl.style.display = 'none';
      errorEl.style.display = 'none';

      const email = form.querySelector('input[name="contact[email]"]').value.trim();
      if (!email) {
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.style.display = 'block';
        return;
      }

      // Build form data
      const formData = new FormData(form);

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          // Success
          successEl.style.display = 'flex';
          form.querySelector('input[type="email"]').value = ''; // clear input
        } else {
          const data = await response.json();
          if (data.errors) {
            errorEl.textContent = data.errors.join(', ');
          } else {
            errorEl.textContent = 'Something went wrong. Please try again.';
          }
          errorEl.style.display = 'block';
        }
      } catch (err) {
        errorEl.textContent = 'Network error. Please check your connection.';
        errorEl.style.display = 'block';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
